import { usePrevious } from '../../../customHooks/usePrevious';
import { useAppSelector } from '../../../store/store';
import UserCharactersAlive from './UserCharactersAlive';
import UserCharactersDead from './UserCharactersDead';
import './UserCharacters.scss'

interface IUserCharactersProps {
    playerHp: number
    isWon: boolean
}

const UserCharacters = ({ playerHp, isWon }: IUserCharactersProps) => {
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    const ischoiceActive = useAppSelector(state => state.FightReducer.ischoiceActive)

    const img = mainCharacter.getImgBig()
    const maxHp = mainCharacter.getMaxHp()

    const widthHpBar = Math.round((playerHp / maxHp) * 100)
    const prevHp = usePrevious(playerHp)
    const takenDamage = prevHp - playerHp
    const isAlive = playerHp > 0

    const takenDamageContent = () => {
        let content: any = <></>

        if (takenDamage > 0 && !ischoiceActive) {
            content = <span className="player__content-taken-damage">-{takenDamage}</span>
        }

        if (!takenDamage && !ischoiceActive) {
            content = <span className="player__content-taken-damage">Miss</span>
        }

        if (playerHp <= 0 || isWon) {
            content = null
        }

        return content
    }

    return (
        <div className="player">
            <div className="player__content" >
                {isAlive ?
                    <UserCharactersAlive
                        img={img}
                        playerHp={playerHp}
                        maxHp={maxHp}
                        widthHpBar={widthHpBar} />
                    :
                    <UserCharactersDead
                        maxHp={maxHp}
                    />
                }
                <span className="player__content-taken-damage"></span>
            </div>
        </div>
    );
};

export default UserCharacters;
